module.exports = __webpack_public_path__ + "img/executionQueueIcon.99686251.svg";